



































import { defineComponent, ref, computed } from '@vue/composition-api';
import sl from '@/serviceLocator';

export default defineComponent({
  setup() {
    const email = ref('');
    const loading = ref(false);
    const emailSent = ref(false);

    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const sendEmail = async () => {
      try {
        loading.value = true;
        await server.sendResetPasswordEmail(email.value);
        emailSent.value = true;
      } catch (err) {
        const { code, message } = err as any;
        if (code === 'auth/invalid-email') {
          actions.showErrorSnackbar(
            'The email you have provided is invalid. Please try again.',
            err as Error
          );
        } else if (code === 'auth/user-not-found') {
          actions.showErrorSnackbar(
            'There is no user associated with the given email address.',
            err as Error
          );
        } else {
          actions.showErrorSnackbar(message, err as Error);
        }
      } finally {
        loading.value = false;
      }
    };

    const title = computed(() =>
      emailSent.value ? 'Check your email' : 'Reset password'
    );
    return {
      email,
      loading,
      emailSent,
      title,
      sendEmail,
    };
  },
});
